<!-- list框组件 -->
<template>
    <div class="list-shell">
        <slot></slot>
    </div>
</template>
<script>
export default {
    
};
</script>
<style lang="less" scoped>
    .list-shell{
		padding: 10px;
		box-sizing: border-box;
		border: 1px #e9eaec solid;
		border-radius: 5px;
		box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.03);
	}
</style>


